"use strict";
/**
 * For math rendered using KaTex and/or MathJax. Use me like <TeX>2x + 3</TeX>.
 */
/* global katex, MathJax, Khan */
// TODO(joel) - require MathJax / katex so they don't have to be global

var PureRenderMixin = require('react-addons-pure-render-mixin');
var React = require('react');
var ReactDOM = require('react-dom');

var katexA11y = require('./katex-a11y.js');

var pendingScripts = [];
var pendingCallbacks = [];
var needsProcess = false;

var process = function process(script, callback) {
    pendingScripts.push(script);
    pendingCallbacks.push(callback);
    if (!needsProcess) {
        needsProcess = true;
        setTimeout(doProcess, 0);
    }
};

var loadMathJax = function loadMathJax(callback) {
    if (typeof MathJax !== "undefined") {
        callback();
    } else if (typeof Khan !== "undefined" && Khan.mathJaxLoaded) {
        Khan.mathJaxLoaded.then(callback);
    } else {
        throw new Error("MathJax wasn't loaded before it was needed by <TeX/>");
    }
};

var doProcess = function doProcess() {
    loadMathJax(function () {
        MathJax.Hub.Queue(function () {
            var oldElementScripts = MathJax.Hub.elementScripts;
            MathJax.Hub.elementScripts = function (element) {
                return pendingScripts;
            };

            try {
                return MathJax.Hub.Process(null, function () {
                    // Trigger all of the pending callbacks before clearing them
                    // out.
                    for (var _iterator = pendingCallbacks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                        var _ref;

                        if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                        } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                        }

                        var callback = _ref;

                        callback();
                    }

                    pendingScripts = [];
                    pendingCallbacks = [];
                    needsProcess = false;
                });
            } catch (e) {
                // IE8 requires `catch` in order to use `finally`
                throw e;
            } finally {
                MathJax.Hub.elementScripts = oldElementScripts;
            }
        });
    });
};

// Make content only visible to screen readers.
// Both collegeboard.org and Bootstrap 3 use this exact implementation.
var srOnly = {
    border: 0,
    clip: "rect(0,0,0,0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px"
};

var TeX = React.createClass({
    displayName: 'TeX',

    propTypes: {
        children: React.PropTypes.node,
        onClick: React.PropTypes.func,
        onRender: React.PropTypes.func,
        style: React.PropTypes.any
    },

    mixins: [PureRenderMixin],

    getDefaultProps: function getDefaultProps() {
        return {
            // Called after math is rendered or re-rendered
            onRender: function onRender() {},
            onClick: null
        };
    },

    componentDidMount: function componentDidMount() {
        var _this = this;

        this._root = ReactDOM.findDOMNode(this);

        if (this.refs.katex.childElementCount > 0) {
            // If we already rendered katex in the render function, we don't
            // need to render anything here.
            this.props.onRender(this._root);
            return;
        }

        var text = this.props.children;

        this.setScriptText(text);
        process(this.script, function () {
            return _this.props.onRender(_this._root);
        });
    },

    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
        var _this2 = this;

        // If we already rendered katex in the render function, we don't
        // need to render anything here.
        if (this.refs.katex.childElementCount > 0) {
            if (this.script) {
                // If we successfully rendered KaTeX, check if there's
                // lingering MathJax from the last render, and if so remove it.
                loadMathJax(function () {
                    var jax = MathJax.Hub.getJaxFor(_this2.script);
                    if (jax) {
                        jax.Remove();
                    }
                });
            }

            this.props.onRender();
            return;
        }

        var newText = this.props.children;

        if (this.script) {
            loadMathJax(function () {
                MathJax.Hub.Queue(function () {
                    var jax = MathJax.Hub.getJaxFor(_this2.script);
                    if (jax) {
                        return jax.Text(newText, _this2.props.onRender);
                    } else {
                        _this2.setScriptText(newText);
                        process(_this2.script, _this2.props.onRender);
                    }
                });
            });
        } else {
            this.setScriptText(newText);
            process(this.script, this.props.onRender);
        }
    },

    componentWillUnmount: function componentWillUnmount() {
        var _this3 = this;

        if (this.script) {
            loadMathJax(function () {
                var jax = MathJax.Hub.getJaxFor(_this3.script);
                if (jax) {
                    jax.Remove();
                }
            });
        }
    },

    setScriptText: function setScriptText(text) {
        if (!this.script) {
            this.script = document.createElement("script");
            this.script.type = "math/tex";
            ReactDOM.findDOMNode(this.refs.mathjax).appendChild(this.script);
        }
        if ("text" in this.script) {
            // IE8, etc
            this.script.text = text;
        } else {
            this.script.textContent = text;
        }
    },

    render: function render() {
        var katexHtml = null;
        try {
            katexHtml = {
                __html: katex.renderToString(this.props.children)
            };
        } catch (e) {
            /* jshint -W103 */
            if (e.__proto__ !== katex.ParseError.prototype) {
                /* jshint +W103 */
                throw e;
            }
        }

        var katexA11yHtml = null;
        if (katexHtml) {
            try {
                katexA11yHtml = {
                    __html: katexA11y.renderString(this.props.children)
                };
            } catch (e) {
                // Nothing
            }
        }

        return React.createElement(
            'span',
            {
                style: this.props.style,
                onClick: this.props.onClick
            },
            React.createElement('span', { ref: 'mathjax' }),
            React.createElement('span', {
                ref: 'katex',
                dangerouslySetInnerHTML: katexHtml,
                'aria-hidden': !!katexHtml && !!katexA11yHtml
            }),
            React.createElement('span', {
                dangerouslySetInnerHTML: katexA11yHtml,
                style: srOnly
            })
        );
    }
});

module.exports = TeX;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-components/tex.jsx
 ** module id = 178
 ** module chunks = 0 2
 **/